import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export default createReduxConstants('UGC_EDITOR', {
  OPEN_EDITOR: null,
  CLOSE_EDITOR: null
});
